import React, { useEffect, useState } from "react"
import {
  InputGroup,
  InputGroupAddon,
  InputGroupText,
  Input,
  Form,
  Row,
  Col,
  Button
} from "reactstrap"
import { isMobile } from "react-device-detect"
import { Mutation } from "react-apollo"
import login from "../gql/login"

import img1 from "../../../assets/images/logo-icon.png"
import img2 from "../../../assets/images/background/login-register.jpg"

const Login = props => {
  const [email, setEmail] = useState("")
  const [password, setPassword] = useState("")
  const token = localStorage.getItem("token")

  const sidebarBackground = {
    backgroundImage: `url(${img2})`,
    backgroundRepeat: "no-repeat",
    backgroundPosition: "bottom center"
  }
  const isOnSideBar = isMobile ? "auth-box" : "auth-box on-sidebar"

  useRedirectToIndex(token, props)

  return (
    <Mutation mutation={login}>
      {(login, { data }) => {
        if (data) {
          localStorage.setItem("token", data.login.token)

          if (data.login.user.isPasswordNeedToChange === true) {
            props.history.push("/")
            setTimeout(() => {
              props.history.push("/profile/1")
            }, 100)
          } else {
            props.history.push("/")
          }
        }

        return (
          <div className="">
            {/*--------------------------------------------------------------------------------*/}
            {/* Login Cards */}
            {/*--------------------------------------------------------------------------------*/}
            <div
              className="auth-wrapper d-flex no-block justify-content-center align-items-center"
              style={sidebarBackground}
            >
              <div className={isOnSideBar}>
                <div id="loginform">
                  <div className="logo move-in-right">
                    <span className="db">
                      <img src={img1} alt="logo" className="mb-3" />
                    </span>
                    <h5 className="font-medium mb-3">Sign In to Admin</h5>
                  </div>
                  <Row>
                    <Col xs="12">
                      <Form
                        className="mt-3"
                        id="loginform"
                        onSubmit={e => e.preventDefault()}
                      >
                        <InputGroup className="mb-3 move-in-left">
                          <InputGroupAddon addonType="prepend">
                            <InputGroupText>
                              <i className="ti-user" />
                            </InputGroupText>
                          </InputGroupAddon>
                          <Input
                            type="text"
                            placeholder="帳號"
                            required
                            onChange={e => setEmail(e.target.value)}
                            value={email}
                          />
                        </InputGroup>
                        <InputGroup className="mb-3 move-in-left">
                          <InputGroupAddon addonType="prepend">
                            <InputGroupText>
                              <i className="ti-pencil" />
                            </InputGroupText>
                          </InputGroupAddon>
                          <Input
                            type="password"
                            placeholder="Password"
                            required
                            onChange={e => setPassword(e.target.value)}
                            value={password}
                          />
                        </InputGroup>
                        <Row className="mb-3">
                          <Col xs="12">
                            <Button
                              color="primary"
                              size="lg"
                              type="submit"
                              block
                              disabled={email === "" || password === ""}
                              className="border-0 move-in-bottom"
                              style={{
                                background: "var(--getech-gradient)"
                              }}
                              onClick={() => {
                                email !== "" &&
                                  password !== "" &&
                                  login({ variables: { email, password } })
                              }}
                            >
                              Log In
                            </Button>
                          </Col>
                        </Row>
                      </Form>
                    </Col>
                  </Row>
                </div>
              </div>
            </div>
          </div>
        )
      }}
    </Mutation>
  )
}

/*
// <Row>
                        //   <Col>
                        //     <button
                        //       onClick={() => {
                        //         setEmail("n01@getech.com")
                        //       }}
                        //     >
                        //       切換北區業助
                        //     </button>
                        //     <button
                        //       onClick={() => {
                        //         setEmail("s01@getech.com")
                        //       }}
                        //     >
                        //       切換南區業助
                        //     </button>
                        //     <button
                        //       onClick={() => {
                        //         setEmail("s02@getech.com")
                        //       }}
                        //     >
                        //       切換南區業助2
                        //     </button>
                        //     <button
                        //       onClick={() => {
                        //         setEmail("brian@4idps.com")
                        //       }}
                        //     >
                        //       切換北區客戶
                        //     </button>
                        //     <button
                        //       onClick={() => {
                        //         setEmail("alan@4idps.com")
                        //       }}
                        //     >
                        //       切換北區採購權客戶
                        //     </button>
                        //     <button
                        //       onClick={() => {
                        //         setEmail("steven@tsmc.com")
                        //       }}
                        //     >
                        //       切換南區客戶
                        //     </button>
                        //     <button
                        //       onClick={() => {
                        //         setEmail("frank@tsmc.com")
                        //       }}
                        //     >
                        //       切換南區採購權客戶
                        //     </button>
                        //   </Col>
                        // </Row>
*/

const useRedirectToIndex = (token, props) => {
  useEffect(() => {
    if (token !== "" && props.location?.pathname === "/login") {
      props.history.push("/")
    }
  }, [token, props])
}

export default Login
